import React, { useContext, useEffect, useMemo, useState } from 'react'
import {
  BookNowStrip,
  ProfessionalCategoryButton,
  ProfessionalEventItem,
  ProfessionalItemDescription,
  ProfessionalItemHeading,
  ProfessionalsCategoryContainer,
  ProfessionalSeparator,
  ProfessionalsItemContainer,
  ProfessionalsItemPicture,
  ProfessionalsItemsListContainer,
  ProfessionalsListBackgroundPage,
  ProfessionalsListHeading,
  ProfessionalsListInternalPage,
  ProfessionalsMainContent,
} from './ProfessionalsListStyles'
import { useNavigate } from 'react-router-dom'
import { getFormattedCount } from '../DailyPlay/DailyPlayComponents'
import AccessTimeFilledIcon from '@mui/icons-material/AccessTimeFilled'
import PeopleIcon from '@mui/icons-material/People'
import { getImageLink } from 'src/mentor/helpers/utilityFunctions'
import { getCategoryListMap } from 'src/consumer/helpers/courseCardHelper'
import { GenericDisplayFlex } from 'src/mentor/layout/Styles'
import Tooltip from '@mui/material/Tooltip'
import { LocalizationContext } from 'src/consumer/context/LocalizationContext'

export default function ProfessionalsListPage(props) {
  const { setupData, fromOnboarding, oneOnOneMentorsData } = props
  const navigate = useNavigate()
  const [selectedCategory, setSelectedCategory] = useState()
  const [expandedDescriptions, setExpandedDescriptions] = useState({})

  const { localizedData } = useContext(LocalizationContext)
  const myLiveSessionsStrings = localizedData?.strings?.myLiveSessionsPage

  console.log({ setupData })

  // console.log('in professional listing page, setup data is:')
  // console.log(setupData)

  // if (!Boolean(oneOnOneMentorsData)) {
  //   console.log('no one on one data')
  // }

  // const showProfessionalBoolean = (professional) =>

  const filteredMasters = oneOnOneMentorsData?.filter(
    (professional) => professional?.services?.live,
  )

  // from category Id to mentors map function
  const getCategoryToMentorsArrayObject = (filteredMasters) => {
    const finalCategoryToMentorObject = filteredMasters?.reduce((acc, masterItem) => {
      masterItem?.categories?.forEach((categoryId) => {
        acc[categoryId] = [...(acc?.[categoryId] || []), masterItem]
      })
      return acc
    }, {})

    // filteredMasters?.forEach((professional) => {
    //   professional?.categories?.forEach((categoryId) => {
    //     finalCategoryToMentorObject[categoryId] = []
    //   })
    // })
    // filteredMasters?.forEach((professional) => {
    //   professional?.categories?.forEach((categoryId) => {
    //     finalCategoryToMentorObject[categoryId].push(professional)
    //   })
    // })
    return finalCategoryToMentorObject
  }

  // CALLING : from category Id to mentors map function
  const categoryToMentorObject = getCategoryToMentorsArrayObject(filteredMasters)

  const categoryListMap = useMemo(() => {
    return getCategoryListMap(setupData)
  }, [setupData])

  const allAvailableAllowedCategories = Object.keys(categoryToMentorObject || {}).filter(
    (item) => categoryListMap?.get(item)?.name && categoryListMap?.get(item)?.enabled,
  )

  // setting first selected category
  useEffect(() => {
    const arrayOfItems = Object.keys(categoryToMentorObject || {}).filter(
      (item) => categoryListMap?.get(item)?.name && categoryListMap?.get(item)?.enabled,
    )
    if (arrayOfItems?.includes('therapist')) {
      setSelectedCategory('therapist')
    } else {
      setSelectedCategory(arrayOfItems?.[0])
    }
  }, [])

  // Reset expanded descriptions when category changes
  useEffect(() => {
    setExpandedDescriptions({})
  }, [selectedCategory])

  // useEffect(() => {
  //   console.log({
  //     categoryToMentorObject,
  //     categoryListMap,
  //     allAvailableAllowedCategories,
  //     getCategoryToMentorsArrayObject,
  //     setupData,
  //     filteredMasters,
  //   })
  // }, [
  //   categoryToMentorObject,
  //   categoryListMap,
  //   allAvailableAllowedCategories,
  //   getCategoryToMentorsArrayObject,
  //   setupData,
  //   filteredMasters,
  // ])

  return (
    <ProfessionalsListBackgroundPage>
      <ProfessionalsListInternalPage>
        <ProfessionalsListHeading>
          {myLiveSessionsStrings?.choose_a_professional || 'Choose a Professional'}
        </ProfessionalsListHeading>
        <ProfessionalsMainContent>
          {/* headings */}
          <ProfessionalsCategoryContainer>
            <ProfessionalCategoryLister
              allAllowedCategories={allAvailableAllowedCategories}
              categoryListMap={categoryListMap}
              selectedCategory={selectedCategory}
              setSelectedCategory={setSelectedCategory}
            />

            {/* {allAvailableAllowedCategories?.map((item, index) => {
              return (
                <ProfessionalCategoryButton
                  key={index}
                  active={item === selectedCategory}
                  onClick={() => setSelectedCategory(item)}
                >
                  {categoryListMap?.get(item)?.name}
                </ProfessionalCategoryButton>
              )
            })} */}
          </ProfessionalsCategoryContainer>

          {/* listing */}
          <ProfessionalsItemsListContainer>
            {!categoryToMentorObject?.[selectedCategory] || categoryToMentorObject?.[selectedCategory]?.length === 0 ? (
              <div style={{
                textAlign: 'center',
                padding: '60px 20px',
                color: '#718096',
                fontSize: '18px',
                fontFamily: 'Outfit, sans-serif'
              }}>
                <p style={{ margin: '0 0 8px 0', fontWeight: '600', color: '#4a5568' }}>
                  No professionals available
                </p>
                <p style={{ margin: 0, fontSize: '16px' }}>
                  Please check back later or try a different category
                </p>
              </div>
            ) : (
              categoryToMentorObject?.[selectedCategory]?.map((item, index) => {
              let mentorDataOfNeededId = oneOnOneMentorsData?.find(
                (mentorItem) => mentorItem?.id === item?.id,
              )
              let displayEventTypes = getDisplayEventTypesOfMentor(mentorDataOfNeededId)
              const cardId = `card-${item?.id}-${index}`
              const isExpanded = expandedDescriptions[cardId] || false
              const description = item?.shortDesc || item?.longDesc || ''
              const MAX_DESCRIPTION_LENGTH = 150
              const shouldTruncate = description.length > MAX_DESCRIPTION_LENGTH
              const displayDescription = isExpanded || !shouldTruncate 
                ? description 
                : description.substring(0, MAX_DESCRIPTION_LENGTH) + '...'

              const toggleDescription = () => {
                setExpandedDescriptions(prev => ({
                  ...prev,
                  [cardId]: !prev[cardId]
                }))
              }

              return (
                <ProfessionalsItemContainer key={index}>
                  <ProfessionalsItemPicture
                    clickable={displayEventTypes && displayEventTypes?.length > 0}
                    onClick={() => {
                      if (displayEventTypes && displayEventTypes?.length > 0) {
                        if (fromOnboarding) {
                          navigate(`/mentor/${item?.slug}/events`, {
                            state: { fromOnboarding: true },
                          })
                        } else {
                          navigate(`/mentor/${item?.slug}/events`)
                        }
                      }
                    }} // also add option to change chosen event type
                    image={getImageLink(item?.profilePicId)}
                  >
                    {displayEventTypes && displayEventTypes?.length > 0 && (
                      <BookNowStrip>{myLiveSessionsStrings?.book_now || 'Book now'}</BookNowStrip>
                    )}
                  </ProfessionalsItemPicture>
                  <div style={{ 
                    width: '100%', 
                    display: 'flex', 
                    flexDirection: 'column', 
                    minHeight: '100%',
                    justifyContent: 'space-between'
                  }}>
                    <div style={{ flex: '1 1 auto' }}>
                      <ProfessionalItemHeading>{item?.name}</ProfessionalItemHeading>
                      <ProfessionalItemDescription
                        style={{
                          maxHeight: !isExpanded && shouldTruncate ? '4.8em' : 'none',
                          overflow: !isExpanded && shouldTruncate ? 'hidden' : 'visible',
                          transition: 'max-height 0.3s ease-in-out'
                        }}
                      >
                        {displayDescription}
                        {shouldTruncate && (
                          <span 
                            onClick={toggleDescription}
                            style={{
                              color: '#667eea',
                              cursor: 'pointer',
                              marginLeft: '4px',
                              textDecoration: 'underline',
                              fontWeight: '500',
                              fontSize: '15px',
                              whiteSpace: 'nowrap'
                            }}
                          >
                            {isExpanded ? 'less' : 'more'}
                          </span>
                        )}
                      </ProfessionalItemDescription>
                      <ProfessionalItemDescription bold>
                        <GenericDisplayFlex sb style={{ flexWrap: 'wrap', gap: '16px' }}>
                          {Boolean(item?.hrsTaught) && item?.hrsTaught !== 0 && (
                            <GenericDisplayFlex style={{ gap: '6px', alignItems: 'center' }}>
                              <AccessTimeFilledIcon sx={{ fontSize: 18, color: '#667eea' }} />
                              <span>{getFormattedCount(item?.hrsTaught / 60)} hours taught</span>
                            </GenericDisplayFlex>
                          )}
                          {Boolean(item?.studentsCount) && item?.studentsCount !== 0 && (
                            <GenericDisplayFlex style={{ gap: '6px', alignItems: 'center' }}>
                              <PeopleIcon sx={{ fontSize: 18, color: '#667eea' }} />
                              <span>{getFormattedCount(item?.studentsCount)} students</span>
                            </GenericDisplayFlex>
                          )}
                        </GenericDisplayFlex>
                      </ProfessionalItemDescription>
                    </div>

                    <div style={{ flex: '0 0 auto', marginTop: 'auto', paddingTop: '16px' }}>
                      {displayEventTypes && displayEventTypes?.length > 0 && (
                        <>
                          <ProfessionalSeparator />
                          <ProfessionalItemHeading small>
                            {myLiveSessionsStrings?.services || 'Services'}
                            {':'}
                          </ProfessionalItemHeading>
                          <GenericDisplayFlex style={{ flexWrap: 'wrap', gap: '12px', marginTop: '8px' }}>
                            {displayEventTypes?.map((eventItem, index) => {
                              return (
                                <Tooltip title={eventItem.description || eventItem?.title} key={index} arrow>
                                  <ProfessionalEventItem
                                    key={index}
                                    onClick={() => {
                                      if (fromOnboarding) {
                                        navigate(`/mentor/${item?.slug}/events/${eventItem?.uid}`, {
                                          state: { fromOnboarding: true },
                                        })
                                      } else {
                                        navigate(`/mentor/${item?.slug}/events/${eventItem?.uid}`)
                                      }
                                    }}
                                  >
                                    {eventItem?.title}
                                    {eventItem?.free && (
                                      <span
                                        style={{
                                          background: 'linear-gradient(135deg, #fbbf24 0%, #f59e0b 100%)',
                                          borderRadius: '6px',
                                          padding: '2px 8px',
                                          marginLeft: '8px',
                                          fontSize: '11px',
                                          fontWeight: '700',
                                          color: '#ffffff',
                                          textTransform: 'uppercase',
                                          letterSpacing: '0.5px',
                                          boxShadow: '0 2px 4px rgba(251, 191, 36, 0.3)',
                                        }}
                                      >
                                        FREE
                                      </span>
                                    )}
                                  </ProfessionalEventItem>
                                </Tooltip>
                              )
                            })}
                          </GenericDisplayFlex>
                        </>
                      )}
                    </div>

                    {/* <ProfessionalNextAvailableBox>
                                            <ProfessionalNextAvailableText heading>Next Available</ProfessionalNextAvailableText>
                                            <ProfessionalNextAvailableText>15 August 23, 12:30pm</ProfessionalNextAvailableText>
                                        </ProfessionalNextAvailableBox> */}
                  </div>
                </ProfessionalsItemContainer>
              )
            })
            )}
          </ProfessionalsItemsListContainer>
        </ProfessionalsMainContent>
      </ProfessionalsListInternalPage>
    </ProfessionalsListBackgroundPage>
  )
}

export function getDisplayEventTypesOfMentor(mentorDataOfNeededId) {
  return mentorDataOfNeededId?.eventTypes?.filter(
    (eventItem) =>
      eventItem?.uid &&
      eventItem?.publicEvent &&
      eventItem?.enabled &&
      !Boolean(eventItem?.contextId),
  )
}

function ProfessionalCategoryLister({
  allAllowedCategories,
  categoryListMap,
  selectedCategory,
  setSelectedCategory,
}) {
  // console.log({
  //   allAllowedCategoriesInListerComponent: allAllowedCategories,
  //   categoryListMapInLister: categoryListMap,
  // })

  let modifiedAllowedCategories = [allAllowedCategories]

  if (allAllowedCategories?.includes('therapist')) {
    allAllowedCategories.splice(allAllowedCategories.indexOf('therapist'), 1)
    modifiedAllowedCategories = ['therapist', ...allAllowedCategories]
  }

  return modifiedAllowedCategories?.map((item, index) => {
    return (
      <ProfessionalCategoryItem
        key={item}
        active={item === selectedCategory}
        onClick={() => setSelectedCategory(item)}
        getCategoryTitle={(item) => item?.name}
        item={categoryListMap?.get(item)}
      />
    )
  })
}

function ProfessionalCategoryItem({ active, getCategoryTitle, onClick, item }) {
  return (
    <ProfessionalCategoryButton
      // active={item === selectedCategory}
      active={active}
      // onClick={() => setSelectedCategory(item)}
      onClick={onClick}
    >
      {getCategoryTitle(item)}
    </ProfessionalCategoryButton>
  )
}
